import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ConsignmentQuickAddForm from './ConsignmentQuickAddForm';
import RequireTenantSelection from "../../../components/RequireTenantSelection";
const Page = () => {
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article", children: [_jsx("h2", { className: "article-title", children: "Quick Add or Quote Delivery" }), _jsx(RequireTenantSelection, { children: _jsx(ConsignmentQuickAddForm, {}) })] }) }));
};
export default Page;
